import React from 'react';
import { useTranslation } from 'react-i18next';

const StocktakingReportsListItem = ({ item, warehouses ,index}) => {
  const [t] = useTranslation('global');
  const formattedDate = item?.stocktaking_at ? item.stocktaking_at.substring(0, 10) : '-';

  // إيجاد اسم المخزن بناءً على معرف المخزن
 
  // ترجمة نوع الإذن
  let reqTypeTranslated = '-';
  if(item.req_type?.trim() === 'PASH'){
    reqTypeTranslated = t("reports.Permission_Receipt");
  } else if(item.req_type?.trim() === 'PULL'){
    reqTypeTranslated = t("reports.Permission_Disbursement");
  } else if(item.req_type?.trim() === 'TRANS'){
    reqTypeTranslated = t("reports.Permission_Transfer");
  }

  // عدد المنتجات (في حال كانت البيانات لا تحتوي على هذا الحقل يتم عرض '-' أو يمكن تعديله لاحقاً)
  const numberOfProducts = item.product_count ? item.product_count : '-';

  return (
    <div className="grid grid-cols-12 gap-3 border-t px-4 py-2 cursor-pointer items-center hover:bg-[#251658]/5 hover:font-bold">
      <div className="text-center col-span-1 text-[#251658] text-xs">
      {index + 1}
      </div>
      <div className="text-center col-span-3 text-[#251658] text-xs">
        {item.code || '-'}
      </div>
      <div className="text-center col-span-2 text-[#251658] text-xs">
      {item.warehouse?.name_ar || '-'}
      </div>
      <div className="text-center col-span-3 text-[#251658] text-xs">
      {formattedDate}
      </div>
      <div className="text-center col-span-2 text-[#251658] text-xs">
      {item.created_by || '-'}
      </div>
      <div className="text-center col-span-1 text-[#251658] text-xs">
      {item?.completed ? (
                      <div className="inline-flex items-center gap-1 py-1 px-1 bg-[#E7E1F6] text-[#251658] rounded-full text-xs">
                         {t("stocktaking.Settlement_Completed")}
                      </div>
                    ) : (
                      <div className="inline-flex items-center gap-1 py-1 px-2 bg-[#F2E9FF] text-[#251658] rounded-full text-xs">
                        {t("stocktaking.Settlement_Pending")}
                      </div>
                    )}  
      </div>
    </div>
  );
};

export default StocktakingReportsListItem;
